// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-playlist`;
const categoryurl = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-category`;
const meditationseriesurl = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-series`;

export const GetMeditationPlaylistApi = async (page = 1, limit = 10) => {
  try {
   
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getall", page, limit }) }),
    });
    // console.log("Response from API:", response);

    if (!response.ok) throw new Error("Failed to fetch meditation series list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteMeditationPlaylist = async (seriesId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Series ?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: JSON.stringify({ action: "delete",_id: seriesId}) }),
      });

      const data = await response.json();
      if (data.success) toast.success("Playlist deleted successfully");
      else toast.warning("Series deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};


export const updateShowOnHome = async (id, status, refreshCallback) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        data: { 
          action: "edit", 
          _id: id, 
          showOnHome: status 
        } 
      }),
    });

    const data = await response.json();
    if (response.ok) {
      toast.success("Visibility updated successfully");
      if (refreshCallback) refreshCallback();
    } else {
      toast.error(data.message || "Failed to update visibility");
    }
  } catch (error) {
    console.error("Update error:", error);
    toast.error("Something went wrong while updating visibility.");
  }
};

export const submitMeditationPlaylistApi = async (seriesData) => {
  console.log('seriesdata',seriesData);
  const actionType = seriesData._id ? "edit" : "add";

  const formData = new FormData();
  formData.append("data", JSON.stringify({
      action: actionType,
      title: seriesData.title,
      description: seriesData.description,
      duration: seriesData.duration,
      seriesId: seriesData.meditationseries,
      category: seriesData.category,
      languages: seriesData.languages,
      voiceId: seriesData.voice,
      voice: seriesData.voiceName,
      text: seriesData.text,
      system_prompt: seriesData.system_prompt,
      user_prompt: seriesData.user_prompt,
      showOnHome: seriesData.showOnHome,
      _id: seriesData._id || null,
  }));

  if (seriesData.imageFile) {
    formData.append("thumbnail", seriesData.imageFile);
  }

  if (seriesData.voiceFile) {
    formData.append("voice", seriesData.voiceFile);
  }

  

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.success || response.status === 200 || response.status === 201) {
      toast.success(seriesData._id ? "Series updated successfully" : "Series added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save Series");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the Series");
    return null;
  }
};
export const getMeditationSeriesByIdApi = async (id) => {
  try {
    const payload = {
      
      data: { _id: id ,action: "getById"}
    }
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (result.success) return result;
    else toast.error("Failed to load series");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
export const getMeditationCategories = async () => {
  try {
   
    const response = await fetch(categoryurl, {
      method: "Get",
      headers: { "Content-Type": "application/json" },
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load series");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};

export const getMeditationSeries = async () => {
   try {
    const response = await fetch(meditationseriesurl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall"}),
    });
    // console.log("Response from API:", response);

    const result = await response.json();
     return result;
    
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
